import React from 'react';
import { useTranslation } from 'react-i18next';

interface NavigationTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  className?: string;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  activeTab,
  onTabChange,
  className = '',
}) => {
  const { t } = useTranslation();

  const tabs = [
    { id: 'play', label: t('tabs.play') },
    { id: 'recent', label: t('tabs.recent') },
    { id: 'leaderboard', label: t('tabs.leaderboard') },
    { id: 'friends', label: t('tabs.friends') },
  ];
  return (
    <div className={`bg-app-surface rounded-xl p-1 mb-6 ${className}`}>
      <div className="flex space-x-1">
        {tabs.map(tab => (
          <button
            key={tab.id}
            data-test-id={`nav-tab-${tab.id}`}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex-1 py-3 px-4 rounded-lg text-sm font-medium transition-smooth
              ${
                activeTab === tab.id
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'bg-[#000] text-text-secondary hover:text-text-primary hover:bg-app-surface-hover'
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavigationTabs;
